import React from 'react';
import dayjs from 'dayjs';
import { Agreements } from '../../../../types/Agreements.types';
import { Box, Card, Typography, Stack, Divider } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { StyledStatusChip } from './AgreementsList';

interface AgreementsTableMobileProps {
  agreements: Agreements[];
  onRowClick: (agreementId: string) => void;
}

export const AgreementsTableMobile = ({
  agreements,
  onRowClick,
}: AgreementsTableMobileProps) => {
  const { t } = useTranslation();

  return (
    <Stack spacing={12}>
      {agreements?.map((agreement) => {
        const agreementLabel =
          agreement.name || agreement.publisher || agreement._id || 'Agreement';
        return (
          <Card
            variant="primary"
            key={agreement._id}
            tabIndex={0}
            aria-label={
              t('agreements.editAgreementRow', {
                name: agreementLabel,
              }) as string
            }
            onClick={() => onRowClick(agreement._id!)}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                onRowClick(agreement._id!);
              }
            }}
          >
            <Stack spacing={2}>
              <Box>
                <Typography variant="caption">
                  {t('agreements.table.publisher')}
                </Typography>
                <Typography variant="body1">{agreement.publisher}</Typography>
              </Box>
              <Divider />
              <Box>
                <Typography variant="caption">
                  {t('agreements.table.title')}
                </Typography>
                <Typography variant="body1">{agreement.name}</Typography>
              </Box>
              <Divider />
              <Box>
                <Typography variant="caption">
                  {t('agreements.table.startDate')}
                </Typography>
                <Typography variant="body1">
                  {agreement.start_date
                    ? dayjs(agreement.start_date).format('YYYY-MM-DD')
                    : '-'}
                </Typography>
              </Box>
              <Divider />
              <Box>
                <Typography variant="caption">
                  {t('agreements.table.endDate')}
                </Typography>
                <Typography variant="body1">
                  {agreement.end_date
                    ? dayjs(agreement.end_date).format('YYYY-MM-DD')
                    : '-'}
                </Typography>
              </Box>
              <Divider />
              <Box>
                <Typography variant="caption">
                  {t('agreements.table.status')}
                </Typography>
                <Box sx={{ mt: 0.5 }}>
                  <StyledStatusChip
                    status={agreement.computed_status}
                    size="small"
                    label={agreement.computed_status || '-'}
                  />
                </Box>
              </Box>
              <Divider />
              <Box>
                <Typography variant="caption">
                  {t('agreements.table.numberOfJournals')}
                </Typography>
                <Typography variant="body1">
                  {agreement.journals_count}
                </Typography>
              </Box>
            </Stack>
          </Card>
        );
      })}
    </Stack>
  );
};
